import { render, staticRenderFns } from "./LdpDanhSachSlide.vue?vue&type=template&id=6f49461e&scoped=true&"
import script from "./LdpDanhSachSlide.vue?vue&type=script&lang=js&"
export * from "./LdpDanhSachSlide.vue?vue&type=script&lang=js&"
import style0 from "./LdpDanhSachSlide.vue?vue&type=style&index=0&id=6f49461e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f49461e",
  null
  
)

export default component.exports